module.exports = __webpack_public_path__ + "static/img/demoacc.4cecd49.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/registerflow-new/demoacc.svg
// module id = NZUU
// module chunks = 4